import type { ChartState } from '@client/state/chart-state.hook';
import { buildLayoutSnapshot } from '@client/features/trading-layouts/layout-snapshot.utils';
import type { WorkspaceLayoutSnapshot } from '@server/trading-layouts/schemas';

export const buildWorkspaceLayoutSnapshot = (
  chartState: Map<string, ChartState>
): WorkspaceLayoutSnapshot => {
  const chartEntries = Array.from(chartState.values());
  const activeChartId =
    chartEntries.length > 0
      ? chartEntries[chartEntries.length - 1]?.id
      : undefined;

  return {
    version: 1,
    activeChartId,
    charts: chartEntries.map(({ id, formState }) => ({
      chartId: id,
      layout: buildLayoutSnapshot(formState)
    }))
  };
};
